module.exports = "/_next/static/images/Privacy-xs-4a81fd3b0fbb1145ffcb1c8867192424.webp";